<script>
import Layout from "@/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { pagingModel } from "@/models/core/pagingModel";
import FruitModal from "@/pages/admin/danhsachbaiviet/widgets/modalFruit.vue";
import CustomTable from "@/components/custom-table.vue";
import SearchCard from "@/components/search-card.vue";
import { traiCayModel } from "@/models/profession/traiCay/traiCayModel";

export default {
  page: {
    title: "Danh sách sản phẩm trái cây",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, FruitModal, CustomTable, SearchCard },
  data() {
    return {
      title: "Danh sách sản phẩm trái cây",
      items: [
        {
          text: "Danh sách sản phẩm trái cây",
          href: '/danh-sach'
        },
        {
          text: "Danh sách",
          active: true,
        }
      ],
      data: [],
      fields: [
        {
          key: 'STT',
          label: 'STT',
          class: 'td-stt text-center font-bold text-primary-custom w-[70px]',
          sortable: false,
          thClass: 'th-custom-style text-center'
        },
        {
          key: "name",
          label: "Tên sản phẩm trái cây",
          class: 'td-username font-body text-sm font-semibold text-on-surface-custom',
          sortable: false,
          thClass: 'th-custom-style'
        },
        {
          key: "tenKhoaHoc",
          label: "Tên khoa học",
          class: 'font-body text-sm text-secondary-custom',
          sortable: false,
          thClass: 'th-custom-style'
        },
        // {
        //   key: "vungTrongTapTrung",
        //   label: "Vùng trồng tập trung",
        //   class: 'font-body text-sm text-on-surface-custom',
        //   sortable: false,
        //   thClass: 'th-custom-style'
        // },
        {
          key: "view",
          label: "Lượt xem",
          class: 'text-center font-body text-sm text-on-surface-custom w-[100px]',
          sortable: false,
          thClass: 'th-custom-style text-center'
        },
        {
          key: "isNoiBat",
          label: "Trạng thái",
          class: 'text-center font-body text-sm text-on-surface-custom w-[100px]',
          sortable: false,
          thClass: 'th-custom-style text-center'
        },
        {
          key: 'process',
          label: 'Xử lý',
          class: 'text-center w-[120px]',
          sortable: false,
          thClass: 'th-custom-style text-center'
        }
      ],
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 25, 50, 100],
      showModal: false, // Quản lý ẩn/hiện Modal Form nhập liệu
      showDeleteModal: false,
      sortBy: "sort",
      filter: null,
      sortDesc: false,
      filterOn: [],
      numberOfElement: 1,
      totalRows: 1,
      selectedFruit: null, // Dữ liệu trái cây được chọn để sửa (truyền sang Modal)
      listCoQuan: [],
      listLoaiCay: [],
      pagination: pagingModel.baseJson(),
      itemFilter: {
        content: null,
        commonId: null,
        isNoiBat: null,
      },
      treeView: [],
      deletedId: null,
    };
  },
  computed: {
    searchFields() {
      return [
        {
          key: "content",
          type: "text",
          label: "Tìm kiếm cây trồng",
          placeholder: "Tìm kiếm theo tiêu đề hoặc tên sản phẩm trái cây...",
          col: 9
        },
        // {
        //   key: "commonId",
        //   type: "select",
        //   label: "Loại cây trồng",
        //   options: this.listLoaiCay ? this.listLoaiCay.map(r => ({ value: r.id, label: r.name })) : [],
        //   placeholder: "Chọn loại cây trồng...",
        //   col: 3
        // },
        {
          key: "isNoiBat",
          type: "select",
          label: "Trạng thái",
          options: [
            { value: true, label: "Nổi bật" },
            { value: false, label: "Bình thường" }
          ],
          placeholder: "Chọn trạng thái...",
          col: 3
        }
      ];
    }
  },
  methods: {
    normalizer(node) {
      if (node.children == null || node.children == 'null') {
        delete node.children;
      }
    },
    async fnGetList() {
      this.$refs.tblList?.refresh()
    },

    async getListLoaiCay() {

      await this.$store.dispatch("common/commonStore/getAll", "DM_LOAITRAICAY").then((res) => {
        (res != null) ? this.listLoaiCay = res.data || [] : this.listLoaiCay = [];
      })
    },

    async handleDelete() {
      if (this.deletedId) {
        await this.$store.dispatch("profession/traiCay/traiCayStore/delete", { _id: this.deletedId }).then((res) => {
          if (res.code === 0) {
            this.fnGetList();
            this.showDeleteModal = false;
          }
          this.$store.dispatch("snackBarStore/addNotify", {
            message: res.message,
            code: res.code
          });
        });
      }
    },
    handleShowDeleteModal(id) {
      this.deletedId = id;
      this.showDeleteModal = true;
    },
    handleShowCreateModal() {
      this.selectedFruit = null; // Trả về Null khi tạo mới sản phẩm
      this.showModal = true; // Kích hoạt hiển thị Modal
    },
    async handleSaveFruit(fruitModel) {
      let loader = this.$loading.show({
        container: this.$refs.formContainer,
      });
      const dataToSave = traiCayModel.toJson(fruitModel);
      if (
        dataToSave._id != 0 &&
        dataToSave._id != null &&
        dataToSave._id
      ) {
        // Gọi API cập nhật thông tin sản phẩm
        await this.$store.dispatch("profession/traiCay/traiCayStore/update", dataToSave).then((res) => {
          if (res.code === 0) {
            this.showModal = false; // Đóng Modal
            this.$refs.tblList.refresh();
          }

          console.info("Log res update:", res.code);

          this.$store.dispatch("snackBarStore/addNotify", {
            message: res.message,
            code: res.code,
          });
        });
      } else {
        // Gọi API thêm mới sản phẩm
        await this.$store.dispatch("profession/traiCay/traiCayStore/create", dataToSave).then((res) => {
          if (res.code === 0) {
            this.showModal = false; // Đóng Modal
            this.fnGetList();
          }
          this.$store.dispatch("snackBarStore/addNotify", {
            message: res.message,
            code: res.code,
          });
        });
      }
      loader.hide();
    },
    async handleUpdate(id) {
      console.info('Log handleUpdate: ', id)
      await this.$store.dispatch("profession/traiCay/traiCayStore/getById", { _id: id }).then((res) => {
        if (res.code === 0) {
          this.selectedFruit = traiCayModel.fromJson(res.data);
          this.showModal = true; // Hiển thị Modal chỉnh sửa sản phẩm khi load xong dữ liệu
        } else {
          this.$store.dispatch("snackBarStore/addNotify", {
            message: res.message,
            code: res.code,
          });
        }
      });
    },
    addCoQuanToModel(node, instanceId) {
      if (node.id) {
        this.itemFilter.menuId = node.id;
      }
    },
    myProvider(ctx) {
      const params = {
        start: ctx.currentPage,
        limit: ctx.perPage,
        sortBy: "sort",
        sortDesc: false,
        isNoiBat: this.itemFilter.isNoiBat || null,
        content: this.itemFilter.content || null,
      }
      this.loading = true
      try {
        let promise = this.$store.dispatch("profession/traiCay/traiCayStore/getPagingParams", params)
        return promise.then(resp => {
          let items = (resp.data && resp.data.data) ? resp.data.data.map(item => traiCayModel.fromJson(item)) : []
          this.totalRows = resp.data ? resp.data.totalRows : 0
          this.numberOfElement = items.length
          this.loading = false
          return items || []
        })
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.$refs.tblList.refresh();
    },
    handleClear() {
      this.itemFilter = {
        content: null,
        commonId: null
      };
      this.$refs.tblList.refresh();
    },
  },
  mounted() {
    this.getListLoaiCay();
  },
  watch: {
    showDeleteModal(val) {
      if (val == false) {
        this.deletedId = null;
      }
    }
  },
};
</script>

<template>
  <Layout>
    <div class="fruit-list-container">

      <!-- Header của trang danh sách -->
      <header class="header-wrapper">
        <div>
          <PageHeader :title="title" :items="items" class="p-0 m-0 border-0" />
        </div>
        <!-- Nút thêm mới trái cây -->
        <button @click="handleShowCreateModal" class="btn-add">
          Thêm trái cây mới
        </button>
      </header>

      <div class="row">
        <div class="col-12">
          <div class="card-premium">

            <!-- Bộ lọc tìm kiếm tái sử dụng cấp cao -->
            <SearchCard :value="itemFilter" :fields="searchFields" @search="handleSearch" @clear="handleClear" />

            <!-- Điều khiển hiển thị số dòng của Bảng -->
            <div class="table-controls-bar">
              <div class="pagination-control-row">
                <span>Hiển thị</span>
                <select v-model="perPage" class="per-page-select">
                  <option v-for="opt in pageOptions" :key="opt" :value="opt">{{ opt }}</option>
                </select>
                <span>dòng trên mỗi trang</span>
              </div>
            </div>

            <!-- Bảng quản trị (Sử dụng component CustomTable tái sử dụng) -->
            <CustomTable :items="myProvider" :fields="fields" striped bordered responsive="sm" :per-page="perPage"
              v-model="currentPage" :number-of-element="numberOfElement" :total-rows="totalRows" :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc" :filter="filter" :filter-included-fields="filterOn" ref="tblList"
              primary-key="id">
              <template v-slot:cell(STT)="data">
                {{ data.index + ((currentPage - 1) * perPage) + 1 }}
              </template>

              <template v-slot:cell(menu)="data">
                <div v-for="(item, index) in data.item.menu" :key="index">
                  <span class="badge bg-warning mb-1">{{ item.name }}</span>
                </div>
              </template>

              <template v-slot:cell(isNoiBat)="data">
                <span v-if="data.item.isNoiBat" class="badge bg-success">Nổi bật</span>
                <span v-else class="badge bg-secondary">Bình thường</span>
              </template>

              <template v-slot:cell(process)="data">
                <div class="action-buttons-flex">
                  <!-- Nút Sửa -->
                  <button type="button" class="btn-edit" @click="handleUpdate(data.item._id)"
                    title="Chỉnh sửa thông tin"></button>

                  <!-- Nút Xoá -->
                  <button type="button" class="btn-del" @click="handleShowDeleteModal(data.item._id)"
                    title="Xóa sản phẩm"></button>
                </div>
              </template>
            </CustomTable>

          </div>
        </div>
      </div>
    </div>

    <!-- NHÚNG COMPONENT REUSABLE FRUIT MODAL BENTO GRID -->
    <FruitModal v-model="showModal" :fruit-data="selectedFruit" @save="handleSaveFruit" />

    <!-- MODAL XÓA DỮ LIỆU CHUẨN THƯƠNG HIỆU -->
    <b-modal v-model="showDeleteModal" centered title="Xóa thông tin đặc sản" title-class="modal-delete-title"
      no-close-on-backdrop>
      <div class="modal-delete-body">
        <span class="isax isax-danger warning-icon"></span>
        <div>
          <p class="warning-main-text">Hành động này không thể hoàn tác!</p>
          <p class="warning-sub-text">
            Dữ liệu trái cây sau khi xóa sẽ vĩnh viễn biến mất khỏi hệ thống tin tức công chúng. Bạn có chắc chắn muốn
            thực
            hiện?
          </p>
        </div>
      </div>

      <template #modal-footer>
        <button type="button" class="btn-close-form" @click="showDeleteModal = false">
          ĐÓNG
        </button>
        <button type="button" class="btn-del" @click="handleDelete">
          ĐỒNG Ý XÓA
        </button>
      </template>
    </b-modal>

  </Layout>
</template>

<style scoped>
/* ======================== THỜI GIAN & CHỦ ĐỀ CHUNG ======================== */
.header-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 32px;
  gap: 16px;
}

@media (min-width: 768px) {
  .header-wrapper {
    flex-direction: row;
    align-items: flex-end;
  }
}

/* Nút thêm mới */
.add-btn-style {
  padding: 12px 24px;
  border-radius: 8px;
  background-color: var(--color-public-primary, #2e7d32);
  color: #ffffff;
  border: none;
  font-family: var(--font-heading, "Montserrat"), sans-serif;
  font-weight: 700;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(46, 125, 50, 0.15);
  transition: all 0.2s ease-in-out;
}

.add-btn-style:hover {
  background-color: #1b5e20;
  box-shadow: 0 4px 12px rgba(46, 125, 50, 0.25);
  transform: translateY(-1px);
}

.icon-btn-add {
  font-size: 18px;
}

/* ======================== THỆ CARD CAO CẤP ======================== */
.card-premium {
  background-color: #ffffff;
  border-radius: 12px;
  border: 1px solid rgba(187, 202, 186, 0.3);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  margin-bottom: 24px;
}

/* Bộ lọc tìm kiếm */
.search-filters-box {
  padding: 24px;
  border-bottom: 1px solid rgba(187, 202, 186, 0.2);
  background: linear-gradient(135deg, rgba(46, 125, 50, 0.02) 0%, rgba(251, 140, 0, 0.02) 100%);
}

.filter-label {
  display: block;
  font-family: var(--font-body, "Inter"), sans-serif;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--color-public-text-body, #374151);
  margin-bottom: 8px;
}

.search-input-wrapper {
  position: relative;
}

.search-input-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(55, 65, 81, 0.5);
  font-size: 18px;
}

.search-input-control {
  width: 100%;
  padding: 12px 16px 12px 44px;
  border: 1px solid var(--outline-variant, #bfcaba);
  border-radius: 8px;
  background-color: #ffffff;
  font-family: var(--font-body, "Inter"), sans-serif;
  font-size: 14px;
  color: var(--color-public-text-body, #374151);
  outline: none;
  transition: border-color 0.2s;
}

.search-input-control:focus {
  border-color: var(--color-public-primary, #2e7d32);
}

/* Nút tìm kiếm & làm mới */
.btn-search-action {
  flex: 1;
  padding: 12px;
  background-color: var(--color-public-primary, #2e7d32);
  color: #ffffff;
  border: none;
  font-family: var(--font-heading, "Montserrat"), sans-serif;
  font-weight: 700;
  font-size: 12px;
  border-radius: 8px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-search-action:hover {
  background-color: #1b5e20;
  box-shadow: 0 4px 10px rgba(46, 125, 50, 0.15);
}

.btn-reset-action {
  padding: 12px 20px;
  background-color: #ffffff;
  color: var(--color-public-text-body, #374151);
  border: 1px solid var(--outline-variant, #bfcaba);
  font-family: var(--font-heading, "Montserrat"), sans-serif;
  font-weight: 700;
  font-size: 12px;
  border-radius: 8px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: background-color 0.15s;
}

.btn-reset-action:hover {
  background-color: var(--surface-container-low, #f1f5eb);
}

/* Điều khiển dòng hiển thị */
.table-controls-bar {
  padding: 16px 24px;
  border-bottom: 1px solid rgba(187, 202, 186, 0.1);
  background-color: rgba(241, 245, 235, 0.3);
}

.pagination-control-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: var(--font-body, "Inter"), sans-serif;
  font-size: 13px;
  color: var(--color-public-text-body, #374151);
}

.per-page-select {
  border: 1px solid rgba(187, 202, 186, 0.5);
  border-radius: 8px;
  padding: 6px 10px;
  font-size: 12px;
  outline: none;
  background-color: #ffffff;
  font-weight: 600;
  color: var(--color-public-text-body, #374151);
}

.primary-custom {
  color: var(--color-public-primary, #2e7d32);
}

.on-surface-custom {
  color: var(--color-public-text-body, #374151);
}

/* Hộp nút thao tác xử lý trong dòng bảng */
.action-buttons-flex {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.action-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(187, 202, 186, 0.3);
  background-color: transparent;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-success-custom {
  color: var(--color-status-success, #4caf50);
}

.btn-success-custom:hover {
  background-color: rgba(76, 175, 80, 0.08);
  border-color: var(--color-status-success, #4caf50);
}

.btn-danger-custom {
  color: var(--color-status-error, #d32f2f);
}

.btn-danger-custom:hover {
  background-color: rgba(211, 47, 47, 0.08);
  border-color: var(--color-status-error, #d32f2f);
}

/* Thanh chân bảng tin */
.table-footer-bar {
  padding: 24px;
  border-top: 1px solid rgba(187, 202, 186, 0.2);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  background-color: rgba(241, 245, 235, 0.1);
}

@media (min-width: 576px) {
  .table-footer-bar {
    flex-direction: row;
  }
}

.footer-stats-text {
  font-family: var(--font-body, "Inter"), sans-serif;
  font-size: 13px;
  color: var(--color-public-text-body, #374151);
}

.stats-highlight {
  font-weight: 700;
  color: var(--color-public-primary, #2e7d32);
}

/* ======================== MODAL XÓA DỮ LIỆU DÙNG CSS PHẦN TỬ ======================== */
::v-deep .modal-delete-title {
  font-family: var(--font-heading, "Montserrat"), sans-serif;
  font-size: 18px;
  color: var(--color-status-error, #d32f2f);
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 8px;
}

.modal-delete-body {
  display: flex;
  align-items: start;
  gap: 12px;
  padding: 4px;
}

.warning-icon {
  color: var(--color-status-error, #d32f2f);
  font-size: 32px;
  flex-shrink: 0;
}

.warning-main-text {
  font-family: var(--font-body, "Inter"), sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: var(--color-public-text-body, #374151);
  margin-bottom: 4px;
}

.warning-sub-text {
  font-family: var(--font-body, "Inter"), sans-serif;
  font-size: 12px;
  color: rgba(55, 65, 81, 0.8);
  margin: 0;
  line-height: 1.5;
}

.btn-cancel-delete {
  background-color: #ffffff;
  border: 1px solid var(--outline-variant, #bfcaba);
  padding: 8px 16px;
  font-family: var(--font-heading, "Montserrat"), sans-serif;
  font-size: 11px;
  font-weight: 700;
  border-radius: 6px;
  cursor: pointer;
  color: var(--color-public-text-body, #374151);
  transition: background-color 0.15s;
}

.btn-cancel-delete:hover {
  background-color: var(--surface-container-low, #f1f5eb);
}

.btn-confirm-delete {
  background-color: var(--color-status-error, #d32f2f);
  border: none;
  padding: 8px 16px;
  font-family: var(--font-heading, "Montserrat"), sans-serif;
  font-size: 11px;
  font-weight: 700;
  border-radius: 6px;
  cursor: pointer;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: background-color 0.15s;
}

.btn-confirm-delete:hover {
  background-color: #b71c1c;
}

/* Custom scrollbar */
::-webkit-scrollbar {
  height: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(112, 122, 108, 0.2);
  border-radius: 4px;
}
</style>